import React, { useCallback } from 'react';
import { useEditor, ReactEditor } from 'slate-react';
import { useSelectedTopLevelIdxs } from '../selected-top-level-idxs';
import { useDndStart } from '../dnd';
import { TasquetMarkdownEditor } from '../../command';
import LeftGutter from '../components/LeftGutter';
import DragHandle from '../components/DragHandle';
const isSelected = (editor, topLevelElement) => {
    if (editor.selection == null) {
        return false;
    }
    const path = ReactEditor.findPath(editor, topLevelElement);
    if (path.length === 0) {
        return false;
    }
    const idx = path[0];
    return TasquetMarkdownEditor.isTopLevelSelected(editor, idx);
};
const DraggableLeftGutter = (props) => {
    const editor = useEditor();
    // This component listens to `selectedTopLevelIdxs` in order to trigger re-rendering when it changes,
    // but the value is not used.
    useSelectedTopLevelIdxs();
    const dragStartHandler = useDndStart();
    return (React.createElement(LeftGutter, { selected: isSelected(editor, props.element) },
        React.createElement(DragHandle, { onDragStart: useCallback((e) => {
                const srcPath = ReactEditor.findPath(editor, props.element);
                const dragIndex = srcPath[0];
                const srcIndices = [dragIndex];
                const selected = isSelected(editor, props.element);
                // If a selected element is dragged, the drag target is expanded to selected neighbors.
                if (selected) {
                    for (let i = dragIndex - 1; i >= 0; --i) {
                        const neighbor = editor.children[i];
                        const neighborSelected = isSelected(editor, neighbor);
                        if (neighborSelected) {
                            srcIndices.unshift(i);
                        }
                        else {
                            break;
                        }
                    }
                    for (let i = dragIndex + 1; i < editor.children.length; ++i) {
                        const neighbor = editor.children[i];
                        const neighborSelected = isSelected(editor, neighbor);
                        if (neighborSelected) {
                            srcIndices.push(i);
                        }
                        else {
                            break;
                        }
                    }
                }
                dragStartHandler({ srcIndices });
                if (selected) {
                    const selection = editor.selection;
                    if (selection &&
                        selection.focus.path[0] !== selection.anchor.path[0]) {
                        // If multiple TopLevelElement-s are selected,
                        // give up to set the preview DOM.
                        return;
                    }
                }
                if (props.previewRef.current) {
                    const previewDom = props.previewRef.current;
                    const previewRect = previewDom.getBoundingClientRect();
                    const offsetX = e.clientX - previewRect.x;
                    const offsetY = e.clientY - previewRect.y;
                    e.dataTransfer.setDragImage(previewDom, offsetX, offsetY);
                }
            }, [dragStartHandler, editor, props.element, props.previewRef]) })));
};
export default React.memo(DraggableLeftGutter);
//# sourceMappingURL=DraggableLeftGutter.js.map